import {
  emailObfuscateRegex,
  emailObfuscateMaskPattern
} from '@/constants';

export default (email) => {
  if(email) {
    return email.replace(emailObfuscateRegex, emailObfuscateMaskPattern);
  }
  return email;
};